import { action } from 'typesafe-actions';

// Types
import { AppUserMergeTypes, AppUserMergeInterface } from './types';

// App User Merge List
export const listAppUserMergeRequest = (payload: object) =>
  action(AppUserMergeTypes.LIST_APP_USER_MERGE_REQUEST, payload);

export const listAppUserMergeSuccess = (payload: {
  appUserMergeList: Array<AppUserMergeInterface>;
  totalCount: number;
}) => action(AppUserMergeTypes.LIST_APP_USER_MERGE_SUCCESS, payload);

export const listAppUserMergeFailure = () =>
  action(AppUserMergeTypes.LIST_APP_USER_MERGE_FAILURE);

// App User Merge Update
export const updateAppUserMergeRequest = (payload: object) =>
  action(AppUserMergeTypes.UPDATE_APP_USER_MERGE_REQUEST, payload);

export const updateAppUserMergeSuccess = () =>
  action(AppUserMergeTypes.UPDATE_APP_USER_MERGE_SUCCESS);

export const updateAppUserMergeFailure = () =>
  action(AppUserMergeTypes.UPDATE_APP_USER_MERGE_FAILURE);

// Current Card
export const currentCard = (payload: { cardIndex: number }) =>
  action(AppUserMergeTypes.APP_USER_MERGE_CURRENT_CARD, payload);
